import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
import 'bootstrap';
import 'jquery-ui-dist/jquery-ui.js';
import 'slick-carousel';
import '../style/main.scss';
import {createPopper} from '@popperjs/core';


jQuery(document).ready(function ($) {


});

